import JILITABLEActions from './JILITABLEActions'

export default class TADATABLEActions extends JILITABLEActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'TABLE',
      gameCode: 'TADA-TABLE-001',
      platform: 'TADA',
    }

    this.gameName = 'Fortune Roulette'
  }
}
